module.exports = __webpack_public_path__ + "static/freddie-harrel-6d426837f399c0ac36aad99e67eea3dd.jpg";